<template>

<button class="action" :data-align="align" :data-theme="theme" v-is:active="isActive" v-is:disabled="isDisabled" v-is:loading="isLoading" v-on:click="$emit('click')">

    <div class="action-text">{{ text }}</div>

    <icon class="action-icon" :n="iconFinal" v-if="hasIcon" />
    
</button>

</template>

<script>

export default {

    props: ['text', 'isActive', 'isDisabled', 'icon', 'theme', 'align', 'isLoading'],

    computed: {

        hasIcon: function() {

            return this.icon || this.isLoading

        },

        iconFinal: function() {

            return (this.isLoading) ? 'loading' : this.icon

        }

    }

}

</script>

<style scoped>

.action {
    border: 1px solid #15C6A4;
    border-radius: 35px;
    height: 70px;
    font-size: 18px;
    line-height: 24px;
    font-weight: 700;
    padding: 0px 70px;
    color: #fff;
    cursor: pointer;
    width: 100%;
    text-align: center;
}

.action.is-active {
    background-color: #15C6A4;
    color: #1A4860;
}

.action.is-disabled {
    pointer-events: none;
}

.action.is-disabled .action-text {
    opacity: 0.25;
}

.action-icon {
    position: absolute;
    right: 35px;
    top: 50%;
    transform: translateY(-50%);
    color: #15C6A4;
    font-size: 20px;
}

.action.is-active .action-icon {
    color: #1A4860;
}

.action[data-align="center"] {
    text-align: center;
}

.action[data-theme="blue"] {
    border-color: #1778FB;
    background-color: #1778FB;
    color: #fff;
}


</style>
